import { useEffect, useRef, useState } from 'react';
import { X, Chrome, Sparkles } from 'lucide-react';

const DISMISSED_KEY = 'extension_banner_dismissed_v1';
const EXTENSION_URL =
  'https://chromewebstore.google.com/detail/promptcodex-gerador-de-pr/fhilaffjonhcbpigpjoohpiojlnegbjk?utm_source=watt';

export function ExtensionBanner() {
  const [visible, setVisible] = useState(false);
  const bannerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    try {
      if (!localStorage.getItem(DISMISSED_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  // Reflect actual rendered height (handles mobile line-wraps) into --banner-h.
  // The fixed navbar reads this variable for its top offset; body spacing stays untouched.
  useEffect(() => {
    const root = document.documentElement;
    if (!visible) {
      root.style.setProperty('--banner-h', '0px');
      return;
    }
    const el = bannerRef.current;
    if (!el) return;
    const apply = () => {
      root.style.setProperty('--banner-h', `${el.offsetHeight}px`);
    };
    apply();
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => {
      ro.disconnect();
      root.style.setProperty('--banner-h', '0px');
    };
  }, [visible]);

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      ref={bannerRef}
      role="region"
      aria-label="Promoção da extensão para Chrome"
      className="fixed top-0 left-0 right-0 z-40 min-h-10 gradient-primary text-primary-foreground shadow-md"
    >
      <div className="relative mx-auto flex min-h-10 w-full items-center justify-center px-10 py-2 sm:px-14">
        <a
          href={EXTENSION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-xs sm:text-sm font-medium hover:underline"
        >
          <Chrome className="h-4 w-4 shrink-0" />
          <span>
            <span className="font-bold">Acelere seus Prompts</span> Direto no ChatGPT, Claude e Gemini
          </span>
          <Sparkles className="h-4 w-4 shrink-0 hidden md:inline" />
          <span className="font-semibold underline-offset-2">
            Instale a extensão PromptCodex para Chrome →
          </span>
        </a>
        <button
          type="button"
          onClick={dismiss}
          aria-label="Fechar banner"
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 shrink-0 rounded-md p-1 hover:bg-primary-foreground/15 transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
